import * as documentsTypes from './documentsTypes';

const initialState = {
  documentIds: [],
  documentIdsFailure: false,
  documentDetail: {},
  documentDetailFailure: false,
  documentDetailName: '',
  documentDetailType: '',
  documentDetailSubtype: '',
  documentDetailEmployeeName: '',
  documentDetailId: '',
  documents: [],
  filters: {},
  tableData: [],
  clients: [],
  documentTypes: [],
  documentIdList: [],
  employees: [],
  documentFields: [],
  showToastMessage: false,
  toastMessage: '',
  activeCaseManagerId: null,
  openDocumentsTab: false,
  caseDetailsDocCount: null,
  isLoading: false,
  downloadInProgress: false,
};

const documentsReducer = (state = initialState, action) => {
  switch (action.type) {
    case documentsTypes.GET_DOCUMENTS_SUCCESS: {
      return { ...state, tableData: action.payload };
    }
    case documentsTypes.HYDRATE_DOCUMENTS_FILTERS:
      return {
        ...state,
        filters: action.filters,
      };
    case documentsTypes.GET_CLIENTS_SUCCESS:
      return { ...state, clients: action.data };
    case documentsTypes.GET_DOCUMENT_TYPES_SUCCESS: {
      const documentTypes = state.documentTypes.slice();

      documentTypes[action.index] = action.data;

      return { ...state, documentTypes };
    }
    case documentsTypes.GET_EMPLOYEES_SUCCESS: {
      const employees = state.employees.slice();

      employees[action.index] = action.data;

      return { ...state, employees };
    }
    case documentsTypes.RESET_DOCUMENT_UPLOAD:
      return { ...state, clients: [], documentTypes: [], documentIds: [], employees: [], documentFields: [] };
    case documentsTypes.DELETE_UPLOAD: {
      const clients = state.clients.slice();
      const documentTypes = state.documentTypes.slice();
      const documentIds = state.documentIds.slice();
      const employees = state.employees.slice();
      const documentFields = state.documentFields.slice();

      clients.splice(action.index, 1);
      documentTypes.splice(action.index, 1);
      documentIds.splice(action.index, 1);
      employees.splice(action.index, 1);
      documentFields.splice(action.index, 1);

      return { ...state, documentTypes, documentIds, employees, documentFields };
    }
    case documentsTypes.RESET_DOCUMENT_FIELDS:
      const documentFields = state.documentFields.slice();

      documentFields[action.index] = null;

      return { ...state, documentFields };
    case documentsTypes.HYDRATE_DOCUMENT_DETAILS:
      return {
        ...state,
        documentDetail: action.payload,
      };
    case documentsTypes.DEHYDRATE_DOCUMENT_DETAILS:
      return {
        ...state,
        documentDetail: {},
        documentDetailName: '',
        documentDetailType: '',
        documentDetailId: '',
      };
    case documentsTypes.GET_DOCUMENT_FIELDS_SUCCESS: {
      const documentFields = state.documentFields.slice();

      documentFields[action.index] = action.data;

      return { ...state, documentFields };
    }
    case documentsTypes.HYDRATE_DOCUMENTS:
      return {
        ...state,
        documents: action.payload,
      };
    case documentsTypes.SHOW_DELETE_NOTIFICATION_SUCCESS:
      return { ...state, showToastMessage: true, toastMessage: action.message };
    case documentsTypes.HIDE_DELETE_NOTIFICATION_SUCCESS:
      return { ...state, showToastMessage: false };
    case documentsTypes.REFRESH_DOCUMENT_STATE:
      return {
        ...state,
        tableData: action.filteredDocs,
      };
    case documentsTypes.SET_DOCUMENT_ID: {
      const documentIds = state.documentIds.slice();

      documentIds.push(action.data);

      return { ...state, documentIds };
    }
    case documentsTypes.STORE_CASEMANAGER_ID: {
      return {
        ...state,
        activeCaseManagerId: action.payload,
      };
    }
    case documentsTypes.OPEN_DOCS_TAB: {
      return {
        ...state,
        openDocumentsTab: action.payload,
      };
    }
    case documentsTypes.INCREMENT_DOC_COUNT: {
      return {
        ...state,
        caseDetailsDocCount: action.payload,
      };
    }
    case documentsTypes.SET_DOCUMENTS_LOADING: {
      return {
        ...state,
        isLoading: action.isLoading,
      };
    }
    case documentsTypes.GET_DOCUMENT_DETAIL_HEADER_SUCCESS: {
      return {
        ...state,
        documentDetailId: action.payload.id,
        documentDetailName: action.payload.name,
        documentDetailType: action.payload.type,
        documentDetailSubtype: action.payload.subtype,
        documentDetailEmployeeName: action.payload.employeeName,
        documentDetailEmployeeGUID: action.payload.employeeGUID,
      };
    }
    default: {
      return state;
    }
  }
};

export { initialState };
export default documentsReducer;
